<template>
  <div class="my-card" v-if="banner">
    <!-- swiper -->
    <swiper :options="swiperOption">
      <swiperSlide v-for="(card, index) in banner" :key="'card' + index">
        <div class="my-card-link">
          <div class="img-box">
            <!-- <img :src="card.ImgUrl"  v-if="card.ImgUrl" @click="upImg(card.ImgUrl)">  -->
            <img src="https://img.zhanshangxiu.com/showonline/file/202007/152f9a71571d460ab3bf8671d4e6d353.jpg" >ryrty
          </div>
        </div>
      </swiperSlide> 
    </swiper>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import { mapActions } from "vuex";
export default {
  name: "swiperCard",
  props: ["banner"],
  data() {
    return { 
      swiperOption: {
        slidesPerView: 4,
        autoplay: true,
        spaceBetween: 10
      }
    };
  }, 
  components: {
    Swiper, SwiperSlide
  },  
  created() { 
  },
  methods: {
    upImg(img){
      this.$emit('UpImg',img)
    },
  }
};
</script>
 
<style scoped lang="scss">
.my-card {
  width: calc(100% - 10px);
  margin: 12.5px auto 0;
  p {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    line-height: 1.5;
    padding-top: 8px;
    padding-bottom: 12px;
    text-align: center;
  }
}
.swiper-slide {
  .my-card-link {
    display: block;
    width: 100%;
  }
  .img-box {
    height: 0;
    padding-bottom: 69.69697%;
    position: relative;
    width: 100%;
    border-radius: 2.5px;
    overflow: hidden;
    border:1px solid #e6e6e6;
    img {
      width: 100%;
      height: 100%;
      position: absolute;
    }
  }
}
</style> 